<div mat-dialog-container>
  @if (netzbetreiber) {
    <form #netzbetreiberForm="ngForm"
          [uflaUniqueValue]="['eicNummer', 'eicNummer2', 'eicNummer3']">
      <div mat-dialog-title style="display: flex; flex-direction: row;">
        <div class="dialog-header" fxFlex fxLayout="column" data-qa="netzbetreiberName">Netzbetreiber
          <div class="netzbetreiberName-title" data-qa="netzbetreiberName">
            <h3>
              @if (!createNew) {
                {{ netzbetreiber.name }}
              }
              @if (createNew) {
                Neuer Netzbetreiber
              }
            </h3>
          </div>
        </div>
        <div class="close" style="margin-left: auto;">
          <button data-qa="netzbetreiber-detail-dialog-close-button" (click)="cancel()" type="button"
                  matMiniFab>
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
          </button>
        </div>
      </div>
      <div mat-dialog-content>
        <div class="input-row">
          <mat-form-field class="full-width">
            <mat-label>Name des Netzbetreibers</mat-label>
            <input [uflaUniqueName]="originalNetzbetreiber.name" matInput required
                   [(ngModel)]="netzbetreiber.name" #name="ngModel" name="name" data-qa="netzbetreiber-name-input"/>
            @if (name?.errors?.uniqueNetzbetreiberName) {
              <mat-error>
                Ein anderer Netzbetreiber besitzt bereits diesen Namen
              </mat-error>
            }
            @if (name?.errors?.required) {
              <mat-error>
                Bitte vergeben Sie einen eindeutigen Namen
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="input-row">
          <mat-form-field id="netzbetreiberTyp" class="full-width">
            <mat-label>Typ</mat-label>
            <mat-select required #netzbetreiberTyp="ngModel" [(ngModel)]="netzbetreiber.typ"
                        name="netzbetreiberTyp">
              <mat-option value="UENB">Übertragunsnetzbetreiber (ÜNB)</mat-option>
              <mat-option value="VNB">Verteilnetzbetreiber (VNB)</mat-option>
              <mat-option value="NVNB_NICHTINTEGRIERT">nVNB nicht integriert</mat-option>
              <mat-option value="NVNB_TEILINTEGRIERT">nVNB teilintegriert</mat-option>
              <mat-option value="NVNB_VOLLINTEGRIERT">nVNB vollintegriert</mat-option>
            </mat-select>
            @if (netzbetreiberTyp?.errors?.required) {
              <mat-error>
                Bitte vergeben Sie eine Organisationstyp
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="input-row">
          <mat-form-field>
            <mat-label>EIC Nummer</mat-label>
            <input [uflaUniqueEicnummer]="originalNetzbetreiber.eicNummer" #eicNummer="ngModel" matInput required
                   [(ngModel)]="netzbetreiber.eicNummer" name="eicNummer"
                   data-qa="eicNummer-input"
                   [value]="eicNummer?.value?.toUpperCase()"/>
            @if (eicNummer?.errors?.uniqueEicNummer) {
              <mat-error>
                Ein anderer Netzbetreiber besitzt bereits diese EIC Nummer
              </mat-error>
            }
            @if (eicNummer?.errors?.required) {
              <mat-error>
                Bitte vergeben Sie eine eindeutige EIC Nummer
              </mat-error>
            }
            @if (eicNummer?.errors?.uniqueValue) {
              <mat-error>Die EIC Nummer muss eindeutig sein</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>EIC Nummer 2</mat-label>
            <input [uflaUniqueEicnummer]="originalNetzbetreiber.eicNummer2" #eicNummer2="ngModel" matInput
                   [(ngModel)]="netzbetreiber.eicNummer2" name="eicNummer2"
                   [value]="eicNummer2?.value?.toUpperCase()"
                   [disabled]="eicNummer?.value?.length <= 0"/>
            @if (eicNummer2?.errors?.uniqueEicNummer) {
              <mat-error>
                Ein Netzbetreiber besitzt bereits diese EIC Nummer
              </mat-error>
            }
            @if (eicNummer2?.errors?.uniqueValue) {
              <mat-error>Die EIC Nummer muss eindeutig sein</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>EIC Nummer 3</mat-label>
            <input [uflaUniqueEicnummer]="originalNetzbetreiber.eicNummer3" #eicNummer3="ngModel" matInput
                   [(ngModel)]="netzbetreiber.eicNummer3" name="eicNummer3"
                   [value]="eicNummer3?.value?.toUpperCase()"
                   [disabled]="eicNummer2?.value?.length <= 0"/>
            @if (eicNummer3?.errors?.uniqueEicNummer) {
              <mat-error>
                Ein Netzbetreiber besitzt bereits diese EIC Nummer
              </mat-error>
            }
            @if (eicNummer3?.errors?.uniqueValue) {
              <mat-error>Die EIC Nummer muss eindeutig sein</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="input-row">
          <mat-form-field class="eicNummerChipList full-width">
            <mat-label>EIC nnVNB</mat-label>
            <mat-chip-grid #eicNummerChipList aria-label="EIC Nummer Eingabe">
              @for (nnvnbEicNummer of netzbetreiber.eicNummerNvnbs; track nnvnbEicNummer) {
                <mat-chip-row [selectable]="selectable"
                              [removable]="removable" (removed)="removeNnvnbEicNummer(nnvnbEicNummer)">
                  {{ nnvnbEicNummer }}
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
              <input
                [matChipInputFor]="eicNummerChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur" [disabled]="netzbetreiber.eicNummerNvnbs?.length >= 10"
                (matChipInputTokenEnd)="addNnvnbEicNumme($event)">
              <mat-hint align="end">{{ netzbetreiber.eicNummerNvnbs?.length || 0 }}/10</mat-hint>
            </mat-chip-grid>
          </mat-form-field>
        </div>
        <div class="input-row">
          <mat-form-field>
            <mat-label>Stromnetzbetreibernummer</mat-label>
            <input [uflaUniqueStromNetzbetreiberNummer]="originalNetzbetreiber.stromNetzbetreiberNummer"
                   #stromNetzbetreiberNummer="ngModel" matInput required minlength="6" maxlength="6"
                   [(ngModel)]="netzbetreiber.stromNetzbetreiberNummer" name="stromNetzbetreiberNummer"
                   data-qa="netzbetreiber-stromNetzbetreiberNummer-input"/>
            @if (stromNetzbetreiberNummer?.errors?.stromNetzbetreiberNummer) {
              <mat-error>
                Ein Netzbetreiber besitzt bereits diese Stromnetzbetreibernummer
              </mat-error>
            }
            @if (stromNetzbetreiberNummer?.errors?.required) {
              <mat-error>
                Bitte vergeben Sie eine eindeutige Stromnetzbetreibernummer
              </mat-error>
            }
            @if (stromNetzbetreiberNummer?.errors?.minlength || stromNetzbetreiberNummer?.errors?.maxlength) {
              <mat-error>
                Die Stromnetzbetreibernummer muss genau sechs stellen lang sein
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Bemerkung</mat-label>
            <input #bemerkung="ngModel" matInput [(ngModel)]="netzbetreiber.bemerkung" maxlength="100" name="bemerkung"
                   data-qa="netzbetreiber-bemerkung-input"/>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Schaltleitung</mat-label>
            <mat-select #schaltleitung="ngModel"
                        [(ngModel)]="netzbetreiber.schaltleitung" name="schaltleitung">
              <mat-option value="">Keine</mat-option>
              <mat-option value="Arnsberg">Arnsberg</mat-option>
              <mat-option value="Berzdorf">Berzdorf</mat-option>
              <mat-option value="Plaidt">Plaidt</mat-option>
              <mat-option value="Wesel">Wesel</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Kundenbetreuer</mat-label>
            <input matInput [(ngModel)]="netzbetreiber.kundenBetreuer" #kundenbBtreuer="ngModel"
                   name="kundenbetreuer"/>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Emailadressen</mat-label>
            <input [uflaValidEmailList]="" matInput [(ngModel)]="netzbetreiber.emailAdressen"
                   #emailAdressen="ngModel" name="emailAdressen"/>
            @if (emailAdressen?.errors?.validEmailList) {
              <mat-error>
                Die Emailadressen müssen gültig sein.
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="input-row">
          @if (canDelete(netzbetreiber.id)) {
            <div>
              <div class="toggle-info-text" id="zuweisung-deaktiviert-toggle-label">Zuweisungen für Netzbetreiber deaktivieren?</div>
              <mat-slide-toggle [(ngModel)]="netzbetreiber.zuweisungDeaktiviert"
                                name="zuweisungDeaktiviert"
                                data-qa="zuweisung-deaktiviert-toggle"
                                aria-labelledby="zuweisung-deaktiviert-toggle-label"
                                (change)="checkOnlyOnWhenUserConfirms($event)"
              >
                @if (netzbetreiber.zuweisungDeaktiviert) {
                  <mat-label>Ja</mat-label>
                } @else {
                  <mat-label>Nein</mat-label>
                }
              </mat-slide-toggle>
              @if (netzbetreiber.zuweisungDeaktiviert) {
                <button
                  class="button-warn"
                  (click)="delete(netzbetreiber)"
                  data-qa="delete-netzbetreiber-button"
                  matButton="filled"
                  type="button"
                >
                  <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
                  Netzbetreiber löschen
                </button>
              }
            </div>
          }
        </div>
      </div>
      <div mat-dialog-actions>
        <div fxFlex fxLayoutAlign="end" fxLayoutGap="1rem">
          <div class="buttons">
            @if (!createNew) {
              <button matButton="outlined" type="button" (click)="resetForm()"
                      [disabled]="!netzbetreiberForm.form.dirty">
                <mat-icon>autorenew</mat-icon>
                Zurücksetzen
              </button>
            }
            <button matButton="outlined" data-qa="close-details-button" (click)="cancel()"
                    type="button"
                    mat-dialog-close="true">
              <mat-icon svgIcon="innogy_picto_close"></mat-icon>
              Abbrechen
            </button>
            <button matButton="filled"
                    data-qa="submit-netzbetreiber-detail-button"
                    type="button"
                    [disabled]="!netzbetreiberForm.valid"
                    (click)="saveNetzbetreiber()">
              <mat-icon>save</mat-icon>
              Speichern
            </button>
          </div>
        </div>
      </div>
    </form>
  }

  <ng-template #errorDialog>
    <h2 matDialogTitle>
      <mat-icon color='warn'>error</mat-icon>
      Fehler
    </h2>
    <p matDialogContent><em>Änderungen konnten nicht gespeichert werden!</em></p>
    <mat-dialog-actions align="end">
      <button matButton="filled" matDialogClose>
        <mat-icon svgIcon="innogy_picto_check">
        </mat-icon>
        Verstanden
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #unableToLoadOrgDialog>
    <h2 matDialogTitle>
      <mat-icon color='warn'>error</mat-icon>
      Fehler
    </h2>
    <p matDialogContent><em>Netzbetreiber konnte nicht geladen werden!</em></p>
    <mat-dialog-actions align="end">
      <button matButton="filled" matDialogClose>
        <mat-icon svgIcon="innogy_picto_check"></mat-icon>
        Verstanden
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
